export { default } from './PageHeading';
export type { PageHeadingProps } from './PageHeading';
